import { useMemo } from "react";
import { SelectProduct } from "../../../types/salon.types";

interface Props {
  selectedProducts: SelectProduct[];
  discount: string;
  tipsAmount: { [key: string]: string };
  receivedAmount: string;
}

export const usePaymentCalculations = ({ selectedProducts, discount, tipsAmount, receivedAmount }: Props) => {
  const subtotal = useMemo(() => selectedProducts.reduce((total, product) => total + parseFloat(product.amount) * (product.quantity || 1), 0), [selectedProducts]);

  const tipsTotal = useMemo(() => Object.values(tipsAmount).reduce((sum, tip) => sum + (parseFloat(tip) || 0), 0), [tipsAmount]);

  const discountValue = parseFloat(discount) || 0;
  const total = useMemo(() => subtotal - discountValue + tipsTotal, [subtotal, discountValue, tipsTotal]);

  const received = parseFloat(receivedAmount || "0");
  const changeAmount = Math.max(0, received - total);
  const remainingAmount = Math.max(0, total - received);

  return { subtotal, tipsTotal, discountValue, total, received, changeAmount, remainingAmount };
};
